export enum EnumLocale {
  ZH_TW = 'zh-tw',
  ZH_CN = 'zh-cn',
  JA_JP = 'ja-jp',
  EN_INT = 'en-int',
  EN_AMERICAS = 'en-americas',
  EN_EMEA = 'en-emea',
  EN_JP = 'en-jp',
  EN_TW = 'en-tw',
  EN_KR = 'en-kr',
  EN_ASIA_PACIFIC = 'en-asia-pacific',
}

export enum EnumRegion {
  AMERICAS = 'americas',
  EMEA = 'emea',
  CN = 'cn',
  JP = 'jp',
  KR = 'kr',
  TW = 'tw',
  ASIA_PACIFIC = 'asia-pacific',
  INT = 'int',
}
